// DS: IL3.7
import React from 'react';
export const Warning = ({ className  })=>{
    return /*#__PURE__*/ React.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "90",
        height: "88",
        viewBox: "0 0 90 88"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "a",
        x1: "105.657%",
        x2: "44.766%",
        y1: "0%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#696969",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#696969"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "b",
        x1: "91.872%",
        x2: "56.634%",
        y1: "12.848%",
        y2: "40.004%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "20%",
        stopColor: "#F3F3F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "40%",
        stopColor: "#E7E7E7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "60%",
        stopColor: "#DADADA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "80%",
        stopColor: "#CECECE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#C2C2C2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "c",
        x1: "-3.002%",
        x2: "27.778%",
        y1: "31.344%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#D1F7EB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00D38F"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "d",
        x1: "88.281%",
        x2: "50%",
        y1: "-157.517%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D38F",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00D38F"
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#a)",
        d: "M45.5 17L71.048 31.75 71.048 61.25 45.5 76 19.952 61.25 19.952 31.75z",
        transform: "rotate(-90 45.5 46.5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#b)",
        d: "M45.5 10L77.11 28.25 77.11 64.75 45.5 83 13.89 64.75 13.89 28.25z",
        transform: "rotate(-90 45.5 46.5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#a)",
        d: "M45.5 17L71.048 31.75 71.048 61.25 45.5 76 19.952 61.25 19.952 31.75z",
        transform: "rotate(-90 45.5 46.5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#c)",
        d: "M63.968 7.671L69.958 17.505 50.254 49.671 41.958 45.608 52.978 9.271z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#d)",
        d: "M41.958 49.671L48.02 53.671 48.02 61.671 41.958 65.671 35.896 61.671 35.896 53.671z",
        transform: "rotate(-65 41.958 57.671)"
    })));
};
